import { BlogCategories } from '@/common/constants/blog';

export const BLOG_CATEGORY_TITLES = {
  [BlogCategories.ARTICLES]: 'Articles',
  [BlogCategories.REAL_LIFE_STORIES]: 'Real Life Stories',
  [BlogCategories.VIDEOS]: 'Videos',
};

export const BLOG_CATEGORY_IMAGE_PATHS = {
  [BlogCategories.ARTICLES]: '/images/blogs/articles-category.jpg',
  [BlogCategories.REAL_LIFE_STORIES]:
    '/images/blogs/real-life-stories-category.jpg',
  [BlogCategories.VIDEOS]: '/images/blogs/videos-category.jpg',
};

const lit = <V extends keyof any>(v: V) => v;
export const ReactionTypes = {
  HEART: lit('heart'),
  THUMBSUB: lit('thumbsub'),
  SMILE: lit('smile'),
};

// eslint-disable-next-line max-len
export type ReactionValueTypes = typeof ReactionTypes[keyof typeof ReactionTypes];
